import { ChangeDetectorRef, Component, OnInit, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Globals } from '../../../../globals';
import { ARService } from '../../ar.service';
import { PlanCreateComponent } from '../plan-create/plan-create.component';
import {DataARPaymentPlanModel} from '../../../../models/accountsReceivable/data-ar-payment-plan.model';
import {DataARLedgerModel} from '../../../../models/accountsReceivable/data-ar-ledger.model';
import { LEDGER_ITEM_STATUS } from 'src/app/models/constants/ledger-item-status.model';

@Component({
  standalone: false,
  selector: 'app-plan-list',
  templateUrl: './plan-list.component.html',
  styleUrls: ['./plan-list.component.css']
})
export class PlanListComponent implements OnInit {

  paymentPlanColumns: string[] = ['created', 'description', 'amount', 'status', 'paymentsLeft', 'view', 'select'];
  ledgerItemColumns: string[] = ['postDate', 'description', 'code', 'amount', 'inPlan', 'select'];

  isLoading: boolean = false;
  PatientId: string;
  paymentPlans: DataARPaymentPlanModel[] = [];
  ledgerItems: DataARLedgerModel[] = [];

  enumLedgerItemTypeDebit: string = '00000078-1000-0000-0000-000000000002';
  //enumLedgerItemStatusPaid: string = '00000083-1000-0000-0000-000000000002';
  //enumLedgerItemStatusVoid: string = '00000083-1000-0000-0000-000000000003';

  constructor(
    public dialogRef: MatDialogRef<PlanListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private globals: Globals,
    private arService: ARService,
    private snackBar: MatSnackBar,
    private changeRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.PatientId = this.globals.currentPatientId;
    this.init();
  }

  async init() {

    this.isLoading = true;

    try {

      const promises: any[] = [
        this.getPaymentPlansForPatient(this.PatientId),
        this.getLedgerForPatient(this.PatientId),
      ];

      const dataResponse = await Promise.all(promises);

      this.paymentPlans = dataResponse[0];
      this.ledgerItems = dataResponse[1];

      this.ledgerItems = this.ledgerItems.filter(item => {
        return (item.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Paid &&
          item.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void &&
          item.enumARLedgerItemTypeID === this.enumLedgerItemTypeDebit);
      });

      this.findLedgerItemsInAPlan(this.ledgerItems, this.paymentPlans);

      this.ledgerItems = this.ledgerItems.sort((a, b) => {
        if (a.DATA_IS_IN_PLAN && b.DATA_IS_IN_PLAN) {
          return 0;
        }
        if (!a.DATA_IS_IN_PLAN && !b.DATA_IS_IN_PLAN) {
          return -1;
        }
        if (a.DATA_IS_IN_PLAN && !b.DATA_IS_IN_PLAN) {
          return 1;
        }
        if (!a.DATA_IS_IN_PLAN && b.DATA_IS_IN_PLAN) {
          return -1;
        }
      });

    } catch (err) {
      console.log('err', err);
      this.createMessage('Something went wrong', 'Error');
    }

    this.isLoading = false;
    this.changeRef.detectChanges();

  }

  getPlanStatus(paymentPlan: DataARPaymentPlanModel) {
    if (paymentPlan.enumPaymentPlanStatusID === LEDGER_ITEM_STATUS.Paid) {
      return 'Paid';
    } else {
      return 'Outstanding';
    }
  }

  findLedgerItemsInAPlan(ledgerItems: DataARLedgerModel[], paymentPlans: DataARPaymentPlanModel[]) {
    paymentPlans.forEach((paymentPlan: DataARPaymentPlanModel) => {
      const ledgerItemsIdsInPlan: string[] = paymentPlan.dataARPaymentPlanLedgerItems.map(item => item.LedgerID);
      const ledgerItemsFound: DataARLedgerModel[] = ledgerItems.filter(item => ledgerItemsIdsInPlan.findIndex(id => id === item.LedgerID) > -1);
      ledgerItemsFound.forEach(item => {
        item.DATA_IS_IN_PLAN = true;
      });
    });
  }

  getPaymentPlansForPatient(PatientId: string): Promise<DataARPaymentPlanModel[]> {
    return this.arService.getPaymentPlansForPatient(PatientId).toPromise();
  }

  getLedgerForPatient(PatientId: string) {
    return this.arService.getLedgerForPatient(PatientId).toPromise();
  }

  calcAdjustedPrice(ledgerItem: DataARLedgerModel) {
    const enumCoverageTypePCT: string = '00000048-1000-0000-0000-000000000001';
    const enumCoverageTypeAmount: string = '00000048-1000-0000-0000-000000000002';

    if (!ledgerItem.dataARTransactionItem) {
      return ledgerItem.Amount;
    }

    if (ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === enumCoverageTypePCT) {

      if (ledgerItem.dataARTransactionItem.DiscountPCT == null || typeof ledgerItem.dataARTransactionItem.DiscountPCT == 'undefined') {
        return ledgerItem.Amount;
      } else {
        return ledgerItem.Amount * ((ledgerItem.dataARTransactionItem.DiscountPCT) / 100);
      }

    }

    if (ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === enumCoverageTypeAmount) {

      if (ledgerItem.dataARTransactionItem.DiscountAmount == null || typeof ledgerItem.dataARTransactionItem.DiscountAmount == 'undefined') {
        return ledgerItem.Amount;
      } else {
        return ledgerItem.Amount - ledgerItem.dataARTransactionItem.DiscountAmount;
      }

    }

    return ledgerItem.Amount;
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  convertUTCDateToLocalDateFromString(dateString) {
    if (!dateString) {
      return null;
    }
    const date = new Date(dateString);
    return this.convertUTCDateToLocalDate(date);
  }

  convertUTCDateToLocalDate(date) {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
  }

  checkForSelectedItem() {
    return this.ledgerItems.filter(item => item.DATA_SELECTED).length;
  }

  checkForSelectedPlan() {
    return this.paymentPlans.filter(item => item.DATA_SELECTED).length;
  }

  checkIfSelectedIsInPlan() {
    const selectedItems = this.ledgerItems.filter(item => item.DATA_SELECTED);
    let flag = false;
    flag = selectedItems.filter(item => item.DATA_IS_IN_PLAN).length > 0;
    return flag;
  }

  checkIfCanSelectItem(item: DataARLedgerModel) {
    const flag1 = item.DATA_IS_IN_PLAN;
    if (flag1) { return false; }
    return true;
  }

  unSelectOtherPlansAndItems(plan: DataARPaymentPlanModel) {
    if (!plan.DATA_SELECTED) {
      return;
    }
    this.paymentPlans.forEach(paymentPlan => {
      if (paymentPlan.PaymentPlanID !== plan.PaymentPlanID) {
        paymentPlan.DATA_SELECTED = false;
      }
    });

    this.ledgerItems.forEach(item => {
      const flag = this.checkIfCanSelectItem(item);
      if (!flag) {
        item.DATA_SELECTED = false;
      }
    });
  }

  getPaymentsLeftCount(plan: DataARPaymentPlanModel) {
    const enumPaymentPlanStatusScheduled = '00000095-1000-0000-0000-000000000001';
    return plan.dataARPaymentPlanItems.filter(item => {
      return item.enumPaymentPlanStatusID === enumPaymentPlanStatusScheduled;
    }).length;
  }

  openPlanCreationWindow(mode: string = 'create', paymentPlanId: string = '', paymentPlansToMerge: DataARPaymentPlanModel[] = [], ledgerItemsToMerge: DataARLedgerModel[] = []) {

    let ledgerItems = [];

    if (mode === 'create') {
      ledgerItems = this.ledgerItems.filter(item => item.DATA_SELECTED);
    } else if (mode === 'merge') {
      paymentPlansToMerge.forEach(plan => {
        const items = plan.dataARPaymentPlanLedgerItems.map(ledgerItem => {
          return ledgerItem.dataARLedger;
        });
        ledgerItems = ledgerItems.concat(items);
      });

      ledgerItems = ledgerItems.concat(ledgerItemsToMerge);
    }

    this.isLoading = true;

    const dialogRef = this.dialog.open(PlanCreateComponent, {
      width: '90%',
      height: '90%',
      data: {
        PatientId: this.PatientId,
        ledgerItems,
        mode,
        paymentPlanId,
        paymentPlansToMerge,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.init();
    }, err => {
      this.init();
    });
  }

  initMergePlan() {
    const selectedPlans = this.paymentPlans.filter(plan => plan.DATA_SELECTED);
    const selectedLedgerItems = this.ledgerItems.filter(item => item.DATA_SELECTED);
    this.openPlanCreationWindow('merge', '', selectedPlans, selectedLedgerItems);
  }

  checkIfCanMergePlan() {
    const hasTwoOrMorePlansSelected = this.checkForSelectedPlan() > 1;
    const hasItemSelected = this.checkForSelectedItem();
    const hasPlanSelected = this.checkForSelectedPlan();
    return hasTwoOrMorePlansSelected || (hasItemSelected && hasPlanSelected);
  }

}
